import { toBoolean } from "#ce/utils/props";

// Mark the first selectable result as the combobox's pending choice: a copy with
// `props.highlighted` set, which sp-list-item renders as the hover-style hint.
// Header, disabled, and non-selectable rows are skipped — Enter must never
// commit those — as are branch rows: whether a branch is committable is
// mode-dependent and resolved downstream (QuantumSelectPanel), so the hint only
// ever targets a leaf. Primitive (string) rows can't carry props, so those
// lists get no hint.
export function markFirstResult(items) {
  const index = items.findIndex(
    (item) =>
      item != null &&
      !item.header &&
      !toBoolean(item.disabled) &&
      !toBoolean(item.props?.disabled) &&
      item.props?.selectable !== false &&
      !toBoolean(item.hasChildren),
  );
  const first = index === -1 ? null : items[index];
  if (first === null || typeof first !== "object") {
    return items;
  }

  const marked = [...items];
  marked[index] = { ...first, props: { ...(first.props ?? {}), highlighted: true } };
  return marked;
}
